export const ConsumptionTypes = [
  {
    value: "Consumption",
    label: "Consumption"
  },
  {
    value: "Production",
    label: "Production"
  }
];


// WEBPACK FOOTER //
// ./src/constants/ConsumptionTypes.js